import { intlFormat } from 'date-fns';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { BodyL, BodyM } from '@sorare/core/src/atoms/typography';
import { useIntlContext } from '@sorare/core/src/contexts/intl';
import { VIRTUAL_TOGGLE_FILTERS } from '@sorare/core/src/lib/filters';

import { Countdown } from 'components/market/Countdown';

import challengerImage from './assets/challenger.png';
import championImage from './assets/champion.png';
import contenderImage from './assets/contender.png';

const Wrapper = styled(Vertical).attrs({ gap: 2, center: true })`
  margin: calc(var(--unit) * 5) 0;
  text-align: center;
  color: var(--c-neutral-1000);
`;

const Image = styled.img`
  width: 150px;
`;

type Props = {
  filter: (typeof VIRTUAL_TOGGLE_FILTERS)[keyof typeof VIRTUAL_TOGGLE_FILTERS];
};

const items = {
  [VIRTUAL_TOGGLE_FILTERS.challengerFilter.name]: {
    image: challengerImage,
    startDate: new Date('2022-11-30T00:00'),
  },
  [VIRTUAL_TOGGLE_FILTERS.championFilter.name]: {
    image: championImage,
    startDate: new Date('2022-11-30T00:00'),
  },
  [VIRTUAL_TOGGLE_FILTERS.contenderFilter.name]: {
    image: contenderImage,
    startDate: new Date('2022-11-30T00:00'),
  },
};

export const EmptyEarlyAccess = ({ filter }: Props) => {
  const { locale } = useIntlContext();
  const item = items?.[filter?.name];
  if (!item) return null;
  return (
    <Wrapper>
      <Image src={item.image} />
      <BodyL color="var(--c-neutral-600)">
        <FormattedMessage
          id="marketplace.emptyEarlyAccess"
          defaultMessage="New season cards are coming soon"
        />
      </BodyL>
      <BodyM color="var(--c-neutral-600)">
        {intlFormat(
          item.startDate,
          {
            weekday: 'long',
            month: 'short',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
          },
          {
            locale,
          }
        )}
      </BodyM>
      <Countdown endDate={item.startDate} expanded={false} />
    </Wrapper>
  );
};
